export default function (value) {
  const regexp = /^#?([A-F0-9]{3}|[A-F0-9]{6})$/i;

  return regexp.test(String(value));
};
